const anchoredAlertStyles = {
  zIndex: 'inherit'
};

export { anchoredAlertStyles as a };
//# sourceMappingURL=anchoredAlert-CUi7Yfgi.js.map
